import React from "react";
import { navigate } from "gatsby";

import { StructuredTextRenderer } from "../../../../components/StructuredTextRenderer";
import { TeaserCard } from "../../../../components/teaser-components/TeaserCard/TeaserCard";

import t from "../../../../lib/translate";

import * as styles from "./CameraAccessoryTeaserElement.module.less";
import { render as plainText } from "datocms-structured-text-to-plain-text";
import { Button } from "../../../../components/Button";
import GeneralPageContext from "../../../../templates/GeneralPageContext";
import { useContext } from "react";

export function CameraAccessoryTeaserElement(
    { data, semanticOfTeaserHeadline, currency },
    hasLightBackground
) {
    const {
        id,
        type,
        name,
        image,
        cameraSeries,
        cameraAccessoryCategory,
        price,
        priceInfoText,
        priceLink
    } = data;

    const {
        stdPages: { pageCameraForm }
    } = useContext(GeneralPageContext);

    const CameraAccessoryTeaserFooterContent = (
        <>
            <table className={styles.formats}>
                <tbody>
                    <tr>
                        <td>{t("camera.accessory.series")}</td>
                        <td>
                            {cameraSeries.map((series) => {
                                return (
                                    <span key={series.id}>{series.name}</span>
                                );
                            })}
                        </td>
                    </tr>
                </tbody>
            </table>

            {price && (
                <span className={styles.price}>{`${price} ${currency}`}</span>
            )}

            {!!plainText(priceInfoText) && (
                <StructuredTextRenderer
                    data={priceInfoText}
                    className={styles.infoText}
                    contentElementType={"CameraAccessoryTeaserElement"}
                />
            )}

            {!!plainText(priceLink) && (
                <StructuredTextRenderer
                    itemLinkType={"cta"}
                    itemLinkIconPosition={"left"}
                    data={priceLink}
                    contentElementType={"CameraAccessoryTeaserElement"}
                    className={styles.priceLink}
                    itemLinkState={{ selectedItemId: id }}
                />
            )}
        </>
    );

    return (
        <div>
            <TeaserCard
                teaserData={{
                    type,
                    image,
                    tagline: cameraAccessoryCategory?.name,
                    headline: name,
                    semanticOfHeadline: semanticOfTeaserHeadline,
                    link: priceLink
                }}
                hideButtonLabel
                noContent
                withHover
                FixedContent={CameraAccessoryTeaserFooterContent}
                hasLightBackground={hasLightBackground}
                customLinkData={{ selectedItemId: id }}
            />
        </div>
    );
}
